/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';
import Button from '../elements/Button';

export default function DiscussProject() {
  return (
    <section className="container mx-auto px-4 lg:px-8 py-20 relative z-10">
      <div className="max-w-4xl mx-auto">
        <div 
          className="contact-form text-center"
          style={{
            background: 'rgba(10, 14, 39, 0.8)',
            border: '2px solid rgba(45, 127, 249, 0.4)',
          }}
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            Ready to Start Your <span className="neon-text">Project?</span>
          </h2>
          <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
            Let&apos;s discuss your ideas and transform them into powerful digital solutions. 
            Our team is ready to bring your vision to life.
          </p>
          
          <Button
            href="/contact"
            type="link"
            className="inline-flex items-center px-8 py-4 text-lg font-bold text-white bg-neon-blue rounded-full transition-all duration-300 hover:scale-105"
            style={{
              background: 'var(--neon-blue)',
              boxShadow: '0 0 30px rgba(45, 127, 249, 0.5)',
            }}
          >
            Discuss Your Project
            <svg 
              className="ml-3 w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M17 8l4 4m0 0l-4 4m4-4H3" 
              />
            </svg>
          </Button>

          <div className="mt-8 flex flex-col sm:flex-row justify-center items-center gap-6 text-sm text-blue-200">
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-neon-blue" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              Quick Response
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-neon-blue" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              Free Consultation
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-neon-blue" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              Expert Team
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
